export const ArrowRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 24"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <path d="M13.5 2C13.7651 2.00023 14.0193 2.10574 14.2067 2.29333L23.2067 11.2933L23.26 11.3533C23.3884 11.4986 23.4718 11.6782 23.5 11.87C23.5067 11.9365 23.5067 12.0035 23.5 12.07C23.4857 12.3092 23.3836 12.5347 23.2133 12.7033L14.2133 21.7033C14.0258 21.8906 13.7717 21.9958 13.5067 21.9958C13.2417 21.9958 12.9875 21.8906 12.8 21.7033C12.6127 21.5158 12.5075 21.2617 12.5075 20.9967C12.5075 20.7317 12.6127 20.4775 12.8 20.29L20.0867 13H2.5C2.23478 13 1.98043 12.8946 1.79289 12.7071C1.60536 12.5196 1.5 12.2652 1.5 12C1.5 11.7348 1.60536 11.4804 1.79289 11.2929C1.98043 11.1054 2.23478 11 2.5 11H20.0867L12.7933 3.70667C12.6061 3.51917 12.5009 3.265 12.5009 3C12.5009 2.735 12.6061 2.48083 12.7933 2.29333C12.9807 2.10574 13.2349 2.00023 13.5 2Z" />
    </svg>
  );
};
